import jwt_decode from 'jwt-decode';
import { get, isArray, isEmpty, set } from 'lodash';
const getUsername = () => {
    if (!window || !window.localStorage || typeof window.localStorage.getItem !== 'function') {
        logMessage('localStorage not defined.');
        return;
    }
    const token = window.localStorage.getItem('accessToken');
    if (token) {
        const decodedToken = jwt_decode(token);
        const username = get(decodedToken, 'email');
        return username;
    }
    return window.localStorage.getItem('username');
};
let PAGE_PROPERTIES_STORAGE_KEY = 'organisation';
let TRACK_PROPERTIES_STORAGE_KEY = 'organisation';
let PAGE_PROPERTIES_STORAGE_ATTRIBUTES = ['id', 'name', 'geoId'];
let TRACK_PROPERTIES_STORAGE_ATTRIBUTES = ['id', 'name', 'geoId'];
let TRACK_PRODUCT_PROPERTIES;
export const rudderstackPropertyKeyInit = (pageKey, trackKey) => {
    PAGE_PROPERTIES_STORAGE_KEY = pageKey || PAGE_PROPERTIES_STORAGE_KEY;
    TRACK_PROPERTIES_STORAGE_KEY = trackKey || TRACK_PROPERTIES_STORAGE_KEY;
};
export const rudderstackProductPropertiesInit = productProperties => {
    TRACK_PRODUCT_PROPERTIES = productProperties || TRACK_PRODUCT_PROPERTIES;
};
export const rudderstackAttributeInit = (pageAttribute, trackAttribute) => {
    if (isArray(pageAttribute) && !isEmpty(pageAttribute)) {
        PAGE_PROPERTIES_STORAGE_ATTRIBUTES = pageAttribute;
    }
    if (isArray(trackAttribute) && !isEmpty(trackAttribute)) {
        TRACK_PROPERTIES_STORAGE_ATTRIBUTES = trackAttribute;
    }
};
export const rudderstackIdentify = args => {
    const rudderstack = window.rudderanalytics || {};
    if (!Object.keys(rudderstack).length) {
        return;
    }
    const traits = Object.assign({}, args);
    delete traits.event;
    rudderstack.identify(args.username, traits, {}, null);
};
export const rudderstackReset = () => {
    const rudderstack = window.rudderanalytics || {};
    if (!Object.keys(rudderstack).length) {
        return;
    }
    rudderstack.reset();
};
export const rudderstackPage = (pageName, properties) => {
    const rudderstack = window.rudderanalytics || {};
    if (!Object.keys(rudderstack).length) {
        logMessage('rudderstack not defined.');
        return;
    }
    if (!window || !window.localStorage || typeof window.localStorage.getItem !== 'function') {
        logMessage('localStorage not defined.');
        return;
    }
    let pageProperties = typeof properties === 'object' && !Array.isArray(properties) ? Object.assign({}, properties) : {};
    const username = getUsername();
    const organisation = window.localStorage.getItem(PAGE_PROPERTIES_STORAGE_KEY);
    const org = organisation ? JSON.parse(organisation) : undefined;
    if (org) {
        const props = PAGE_PROPERTIES_STORAGE_ATTRIBUTES.reduce((result, field, index) => {
            if (!isEmpty(org[field])) {
                if (field === 'id') {
                    set(result, 'orgId', org[field]);
                }
                else {
                    result[PAGE_PROPERTIES_STORAGE_ATTRIBUTES[index]] = org[field];
                }
            }
            return result;
        }, {});
        pageProperties = Object.assign({}, props, { email: username }, pageProperties);
    }
    rudderstack.page(pageName, Object.assign({}, pageProperties, TRACK_PRODUCT_PROPERTIES));
};
export const rudderstackTrack = (args, eventName) => {
    if (!eventName) {
        logMessage('eventName not specified');
        return;
    }
    if (typeof args !== 'object' || !Object.keys(args).length) {
        logMessage('rudderstackTrack args cannot be null');
        return;
    }
    const rudderstack = window.rudderanalytics || {};
    if (!Object.keys(rudderstack).length) {
        logMessage(`rudderstack not defined. eventName: ${eventName}. args: `, args);
        return;
    }
    let traits = Object.assign({}, args, TRACK_PRODUCT_PROPERTIES, { email: getUsername() });
    const organisation = window.localStorage.getItem(TRACK_PROPERTIES_STORAGE_KEY);
    const org = organisation ? JSON.parse(organisation) : undefined;
    if (org) {
        const props = TRACK_PROPERTIES_STORAGE_ATTRIBUTES.reduce((result, field, index) => {
            if (!isEmpty(org[field])) {
                if (field === 'id') {
                    set(result, 'orgId', org[field]);
                }
                else {
                    result[PAGE_PROPERTIES_STORAGE_ATTRIBUTES[index]] = org[field];
                }
            }
            return result;
        }, {});
        traits = Object.assign({}, props, traits);
    }
    delete traits.event;
    rudderstack.track(eventName, traits, () => {
        logMessage('rudderstack event', eventName, traits);
    });
};
const logMessage = (...message) => {
    if (!window || !window.localStorage || typeof window.localStorage.getItem !== 'function') {
        return;
    }
    const doDebug = (window.localStorage.getItem('debug') || '').toLowerCase() === 'true';
    if (doDebug) {
        console.log(...message);
    }
};
//# sourceMappingURL=rudderstackUtils.js.map